module.exports = __webpack_public_path__ + "img/promotion-icon.6192a78.svg?v=1763034624171";